import React from "react";
import powerBiLogo from "../assets/power-bi.svg";
import sapIcon from "../assets/sap_icon.png";
import fioriIcon from "../assets/fiori.png";
import {
  ANALYTICAL_TOOL_URL,
  EMPLOYEE_PORTAL_URL,
  INTERNAL_FIORI_URL,
} from "../routes/constants";

interface AnalyticalToolButtonProps {
  size?: "default" | "small";
}

const AnalyticalToolButton: React.FC<AnalyticalToolButtonProps> = ({
  size = "default",
}) => {
  const openExternalLink = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const menuButtons = [
    { label: "Analytical Tool", url: ANALYTICAL_TOOL_URL, icon: powerBiLogo },
    { label: "Employee Portal", url: EMPLOYEE_PORTAL_URL, icon: sapIcon },
    { label: "Internal SAP-FIORI", url: INTERNAL_FIORI_URL, icon: fioriIcon },
  ];
  const isSmall = size === "small";

  return (
    <div className="flex items-center gap-2">
      {menuButtons.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={() => openExternalLink(item.url)}
          className={`inline-flex items-center justify-start gap-2 rounded-md bg-[#9b54a1] text-white font-semibold hover:bg-culightpurple whitespace-nowrap ${
            isSmall
              ? "px-2.5 py-1 min-h-[2rem] text-xs"
              : "px-3 py-1.5 min-h-[2.25rem] text-13"
          }`}
        >
          <img
            src={item.icon}
            alt=""
            className={`shrink-0 object-contain ${isSmall ? "h-4 w-4" : "h-5 w-5"}`}
            aria-hidden="true"
          />
          <span className="leading-snug">{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AnalyticalToolButton;
